import React, { useCallback, useEffect, useState } from 'react';
import WeekList from '../components/WeekList';
import './educationManagmentPage.css';
import { addWeekApi, deleteWeekApi, getWeeksApi } from '../../services/educationService';
import { toast } from 'react-toastify';
import { sortBy } from 'lodash';
import useDebounce from '../../hooks/useDebounce';

const AdminDashboard = () => {
  const [weeks, setWeeks] = useState([]);
  const [searchText, setSearchText] = useState('');
  const handleAddWeek = async (newWeek) => {
    // Call API or update state here
    const existingWeek = weeks.find(week => week.title === newWeek.title);
    if (existingWeek && !newWeek._id) {
      return;
    }
    // validate for sqeuence number
    if (weeks.some(week => week.weekNumber === newWeek.weekNumber) && !newWeek._id) {
      toast.error("Week Sequence No. already exists");
      return;
    }

    try {
      const response = await addWeekApi(newWeek);
      if (newWeek._id) {
        setWeeks(weeks.map(week => week._id === newWeek._id ? { ...week, ...response.data } : week));

      } else {
        const updatedWeeks = [...weeks, response.data.newWeek];
        updatedWeeks.sort((a, b) => a.weekNumber - b.weekNumber);

        setWeeks(updatedWeeks);
      }

    } catch (error) {
    }

  };

  const handleDeleteWeek = async (weekId) => {

    try {
      const response = await deleteWeekApi(weekId);
      if (response?.status === "SUCCESS") {
        setWeeks(weeks.filter(week => week._id !== weekId));
      }

    } catch (error) {
      toast.error("Failed to delete week.");
    }
  };

  const handleAddDay = (weekId, newDay) => {
    setWeeks(weeks.map(week =>
      week.id === weekId ? { ...week, days: [...week?.days, { ...newDay, id: week?.days.length + 1 }] } : week
    ));
  };

  const handelContentSave = (data) => {
    setWeeks(weeks.map(week =>
      week._id === data.weekId ? { ...week, days: week?.days.map(day => day._id === data.dayId ? { ...day, contentLength: day?.contentLength?.length || 0 + 1 } : day) } : week
    ));
  };




  const fetchWeeks = useCallback(async (searchKey = '') => {
    try {
      const response = await getWeeksApi({ "sortBy": "weekNumber", "searchKey": searchKey });
      if (response) {
        // Assuming response.data contains the weeks array
        setWeeks(response.data.list);
      }
    } catch (error) {
      toast.error("Failed to fetch weeks data.");
    }
  }, []);


  const handelSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handelDaySave = (weekId, dayId, dayData) => {
    setWeeks(weeks.map(week =>
      week._id === weekId ? { ...week, days: week?.days.map(day => day._id === dayId ? { ...day, ...dayData } : day) } : week
    ));
  };
  const debouncedSearch = useDebounce(searchText, 500);

  useEffect(() => {
    // Fetch weeks data when component mounts
    fetchWeeks(debouncedSearch);
  }, [debouncedSearch]);

  const onDeleteContent = (content) => {

    setWeeks(prevWeeks =>
      prevWeeks.map(week => {
        // Check if this week contains the day we want to update
        if (week.days.some(day => day._id === content.dayId)) {
          return {
            ...week,
            days: week.days.map(day => {
              if (day._id === content.dayId) {
                return {
                  ...day,
                  contentLength: Math.max((day.contentLength || 0) - 1, 0),
                };
              }
              return day;
            }),
          };
        }
        return week; // unchanged
      })
    );
  };

  return <WeekList weeks={weeks} searchText={searchText} onSearchWeek={handelSearch} onAddWeek={handleAddWeek} onDeleteWeek={handleDeleteWeek} onAddDay={handleAddDay} handelDaySave={handelDaySave} handelContentSave={handelContentSave} onDeleteContent={onDeleteContent} />;
};

export default AdminDashboard;